export default "__VITE_ASSET__B5NLvCpA__"